export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "back": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Utilisateurs"])},
        "email": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Email"])},
        "role": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rôle"])},
        "role_admin": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Admin"])},
        "role_sales_manager": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Animateur"])},
        "stores_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Points de vente associés"])},
        "stores_subtitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cet animateur ne voit que les points de vente sélectionnés."])},
        "stores_search_placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rechercher un point de vente"])},
        "save": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enregistrer"])},
        "notify_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Points de vente mis à jour"])},
        "notify_text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Les points de vente associés à cet animateur ont bien été enregistrés."])}
      },
      "en": {
        "back": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Users"])},
        "email": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Email"])},
        "role": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Role"])},
        "role_admin": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Admin"])},
        "role_sales_manager": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sales field manager"])},
        "stores_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Associated points of sale"])},
        "stores_subtitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["This sales field manager only sees the selected points of sale."])},
        "stores_search_placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Search a point of sale"])},
        "save": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Save"])},
        "notify_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Points of sale updated"])},
        "notify_text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["The points of sale associated to this sales field manager have been saved."])}
      }
    }
  })
}
